import * as oidc from 'oidc-client-ts';
import { useCallback, useEffect } from 'react';
export default function Component() {
  const load = useCallback(() => {
    window.location.hash = decodeURIComponent(window.location.hash);

    const mgr = new oidc.UserManager({
      authority: `https://parcel2go.test.p2g.ninja/auth`,
      client_id: 'smartsend.cs',
      loadUserInfo: true,
      redirect_uri: '/myaccount/'
    });

    mgr.signinRedirectCallback().then(
      (user) => {
        window.history.replaceState({}, window.document.title, window.location.origin);

        if (user.state) {
          console.log('AUTH CALLBACK', user.state);
          window.location.href = user.state as string;
        } else {
          console.log('AUTH CALLBACK');
          window.location.href = '/';
        }
      },
      (error) => {
        console.error(error);
        window.location.href = '/';
      }
    );
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <>Loading...</>;
}

Component.displayName = 'SignIn';
